import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  private isTokenExpired(currentUser: any): boolean {
    if (!currentUser || !currentUser.expiredAt) {
      return true;
    }

    // Check if token expiration time has passed
    const expirationTime = currentUser.expiredAt * 1000; // Convert to milliseconds
    const currentTime = new Date().getTime();

    return expirationTime < currentTime;
  }

  redirectUnlogged(): boolean {
    const currentUser = this.authService.currentUserValue;

    if (!currentUser || !currentUser.id) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Check if token is expired
    if (this.isTokenExpired(currentUser)) {
      this.notificationService.warning(
        'Session Expired',
        'Your authentication session has expired. Please log in again.',
        5000
      );
      this.authService.logout();
      return false;
    }

    return true;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.redirectUnlogged();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.redirectUnlogged();
  }
}

